<template>
    <b-card-code
        title="Update" 
    >
          <!-- form -->
          <validation-observer
            ref="OrgEditForm"
            #default="{invalid}"      
          >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="editOrg"
          >
                <!-- Name -->
                <b-form-group
                  label="Organization Name"
                  label-for="organization-name">
                    
                    <validation-provider
                      #default="{ errors }"
                      name="org_name"
                      rules="required">
                        <b-form-input
                          id="org_name"
                          v-model="org_name"
                          :state="errors.length > 0 ? false:null"
                          name="org_name"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>

                <b-form-group
                  label="Organization Address"
                  label-for="organization-address">
                    
                        <b-form-input
                          id="org_address"
                          v-model="org_address"
                          name="org_address"
                        />
                        <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                </b-form-group>

                <b-form-group
                  label="Organization Nick Name"
                  label-for="organization-nick-name">
                    
                        <b-form-input
                          id="org_nick_name"
                          v-model="org_nick_name"
                          name="org_nick_name"
                        />
                        <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                </b-form-group>
                <b-button
                  type="submit"
                  variant="primary"
                  :disabled="invalid"
                >
                  Update
                </b-button>
            </b-form>
          </validation-observer>

  </b-card-code>
</template>
<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BAlert, VBTooltip,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
// import { BTable } from 'bootstrap-vue'
// import { BPagination } from 'bootstrap-vue'

export default {
  components: {
    BCardCode,
    BForm,
    BFormInput,
    BFormGroup,
    BRow,
    BButton,
    BCol, 
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      org_id: "",
      org_name: "",
      org_address: "",
      org_nick_name: ""
    }
  },
  created: function () {
    this.load();
  },
  methods: {
    load: function () {
        // id = this.$route.params.id
        const options = {
            method: 'GET',
            headers: { 'content-type': 'application/json' },
            url: process.env.VUE_APP_BASEURL+'organization/organization/'+this.$route.params.id,
          }
          this.$http(options).then( ( res ) => {
              console.log(res)
              this.org_id = res.data.org_id
              this.org_name = res.data.org_name
              this.org_address = res.data.org_address
              this.org_nick_name = res.data.org_nick_name
              // this.toastMessage(res)  // method call to method2 
              // this.items = res.data.results;
            } )
    },
    editOrg: function() {
        this.$refs.OrgEditForm.validate().then(success => {
        if (success) {
          //call to axios
          console.log("success")
            let data = {
              org_name: this.org_name,
              org_address: this.org_address,
              org_nick_name: this.org_nick_name
            }
            const options = {
              method: 'PATCH',
              headers: { 'content-type': 'application/json' },
              data:data,
              url: process.env.VUE_APP_BASEURL+'organization/organization/'+this.$route.params.id+"/",
          }
          this.$http(options).then( ( res ) => {
            console.log(res)
            if(res.data.org_id){
               this.$router.push({name: 'Organizations'});
            }
          })
        }  
        })
      }
  }
}
</script>

